// extracted by mini-css-extract-plugin
export const container = "socials-module--container--3hptK";